import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@sweetspot/scramble-ds'
import { Button } from '@sweetspot/scramble-ds/atoms'

type ImportErrorDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  error: string
  onRetry: () => void
  isRetryDisabled: boolean
}

export const ImportErrorDialog = ({
  open,
  onOpenChange,
  error,
  onRetry,
  isRetryDisabled,
}: ImportErrorDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent variant="bottom">
        <DialogHeader className="py-4">
          <DialogTitle>{t('memberships.membershipImports.instructions.error_title')}</DialogTitle>
          <DialogDescription className="flex flex-col gap-4">
            <span className="block pt-2">{error}</span>

            {t('memberships.membershipImports.instructions.error_header')}
            <span className="block">
              {t('memberships.membershipImports.instructions.error_description')}
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant="ghost-dark"
              type="button"
              size="large"
              className="ring-0 hover:bg-transparent hover:shadow-none active:ring-0"
              onClick={() => onOpenChange(false)}
            >
              {t('words.cancel')}
            </Button>
          </DialogClose>
          <Button
            variant="primary"
            size="large"
            type="submit"
            disabled={isRetryDisabled}
            onClick={() => {
              onRetry()
              onOpenChange(false)
            }}
          >
            {t('sentences.tryAgain')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
